import React, { useState, useEffect } from "react";
import { ASSET_ACCESSORY_API } from "@app/utils/apiUrl";
import { Put } from "@app/utils/httpProvider";
import Modal from 'react-bootstrap/Modal';

const AccessoryEditModal = ({ show, editItem, onClose, onSave }) => {

    const [formData, setFormData] = useState({
        quantity: "",
        accessoryStatus: "",
        note: ""
    });

    // 1. Thêm state quản lý lỗi
    const [errors, setErrors] = useState({});

    // Khi mở modal -> load data từ editItem
    useEffect(() => {
        if (editItem) {
            setFormData({
                quantity: editItem.quantity || "",
                accessoryStatus: editItem.accessoryStatus || "",
                note: editItem.note || ""
            });
            // Reset lỗi mỗi khi mở modal sửa một item mới
            setErrors({});
        }
    }, [editItem]);

    // 2. Hàm validation kiểm tra số lượng
    const validateForm = () => {
        const newErrors = {};

        // Kiểm tra số lượng
        if (!formData.quantity && formData.quantity !== 0) {
            newErrors.quantity = "Vui lòng nhập số lượng.";
        } else if (Number(formData.quantity) <= 0) {
            newErrors.quantity = "Số lượng phải lớn hơn 0.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Trả về true nếu không có lỗi
    };

    // xử lý change input
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Xóa thông báo lỗi khi người dùng bắt đầu nhập lại
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    // gọi API update
    const handleSubmit = async () => {
        // 3. Gọi validation trước khi chạy logic update
        if (!validateForm()) {
            return;
        }

        if (!editItem) return;

        const payload = {
            assetId: editItem.assetId,
            materialId: editItem.materialCatalogId,
            quantity: Number(formData.quantity),
            accessoryStatus: formData.accessoryStatus,
            note: formData.note,
            isDeleted: false
        };
        
        // kiểm tra có thay đổi không
        const isChanged =
            Number(editItem.quantity) !== payload.quantity ||
            editItem.accessoryStatus !== payload.accessoryStatus ||
            (editItem.note || "") !== (payload.note || "");

        if (!isChanged) {
            handleCancel();
            return;
        }
        try {
            const data = await Put(`${ASSET_ACCESSORY_API.UPDATE_ITEM}`, editItem.id, payload);

            // trả data về component cha
            if (onSave) {
                onSave(data);
            }

            onClose();

        } catch (error) {
            console.error(error);
            alert("Không thể cập nhật phụ kiện");
        }
    };

    // hủy
    const handleCancel = () => {
        setFormData({
            quantity: "",
            accessoryStatus: "",
            note: ""
        });
        setErrors({}); // Xóa lỗi khi hủy

        if (onClose) {
            onClose();
        }
    };

    return (
        <Modal 
            show={show} 
            onHide={handleCancel} 
            size="md"
            centered
            animation={true}
        >
            {/* Header */}
            <Modal.Header>
                <Modal.Title className="font-weight-bold">
                    Sửa phụ kiện
                </Modal.Title>
                <button
                    type="button"
                    className="close"
                    onClick={handleCancel}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>

            {/* Body */}
            <Modal.Body className="p-4">
                <div className="container-fluid px-0">
                    {/* Số lượng */}
                    <div className="mb-3">
                        <label className="font-weight-bold mb-1">
                            Số lượng <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            // Thêm class is-invalid của bootstrap nếu có lỗi
                            className={`form-control ${errors.quantity ? 'is-invalid' : ''}`}
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleChange}
                        />
                        {/* Hiển thị lỗi Số lượng */}
                        {errors.quantity && <div className="text-danger mt-1">{errors.quantity}</div>}
                    </div>

                    {/* Trạng thái */}
                    <div className="mb-3">
                        <label className="font-weight-bold mb-1">Trạng thái</label>
                        <select
                            className="form-control"
                            name="accessoryStatus"
                            value={formData.accessoryStatus}
                            onChange={handleChange}
                        >
                            <option value="Hoạt động">Hoạt động</option>
                            <option value="Không hoạt động">Không hoạt động</option>
                        </select>
                    </div>

                    {/* Ghi chú */}
                    <div className="mb-4">
                        <label className="font-weight-bold mb-1">Ghi chú</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            name="note"
                            value={formData.note}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                </div>
            </Modal.Body>

            {/* Footer */}
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    className="btn btn-primary mr-2"
                    onClick={handleSubmit}
                >
                    Cập nhật
                </button>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                >
                    Huỷ
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AccessoryEditModal;